import { Link } from "react-router-dom";
import { Mail, MapPin, Phone, Building2 } from "lucide-react";
import { useSite } from "@/context/SiteContext";
import { assetUrl, lines } from "@/lib/api";
import { SmartLink } from "@/components/site/SmartLink";

const ColTitle = ({ children }) => <h4 className="text-white text-lg font-semibold mb-5">{children}</h4>;
const linkCls = "text-sm text-white/70 hover:text-brass transition-colors duration-200";

export const Footer = () => {
  const { content } = useSite();
  const f = content.footer;
  const c = content.contact;
  const cats = content.categories.items.filter((x) => !x.hidden);
  const menu = lines(f.menu_links).map((l) => l.split("|"));
  return (
    <footer className="bg-charcoal border-t-4 border-brand text-white" data-testid="site-footer">
      <div className="max-w-[1280px] mx-auto px-6 py-16 grid gap-12 sm:grid-cols-2 lg:grid-cols-[1.4fr_1fr_1fr_1.3fr]">
        <div>
          <Link to="/" data-testid="footer-logo"><img src={assetUrl(content.general.logo)} alt={content.general.site_name} className="h-11 w-auto" /></Link>
          <p className="mt-5 text-sm leading-relaxed text-white/70">{f.description}</p>
        </div>
        <div>
          <ColTitle>{f.menu_title}</ColTitle>
          <ul className="space-y-3">
            {menu.map(([label, to], i) => <li key={i}><SmartLink to={to} className={linkCls} data-testid={`footer-menu-${i}`}>{label}</SmartLink></li>)}
          </ul>
        </div>
        <div>
          <ColTitle>{f.options_title}</ColTitle>
          <ul className="space-y-3">
            {cats.map((x) => <li key={x.slug}><Link to={`/listing-options#${x.slug}`} className={linkCls} data-testid={`footer-cat-${x.slug}`}>{x.title}</Link></li>)}
          </ul>
        </div>
        <div>
          <ColTitle>{f.contact_title}</ColTitle>
          <ul className="space-y-3 text-sm text-white/70">
            <li className="flex gap-3"><Building2 className="h-4 w-4 mt-0.5 text-brass shrink-0" />{c.company}</li>
            <li className="flex gap-3"><MapPin className="h-4 w-4 mt-0.5 text-brass shrink-0" />{c.address}</li>
            <li className="flex gap-3"><Mail className="h-4 w-4 mt-0.5 text-brass shrink-0" /><a href={`mailto:${c.email}`} className="hover:text-brass break-all" data-testid="footer-email">{c.email}</a></li>
            <li className="flex gap-3"><Phone className="h-4 w-4 mt-0.5 text-brass shrink-0" />{c.phone}</li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/10">
        <p className="max-w-[1280px] mx-auto px-6 py-6 text-xs text-white/50" data-testid="footer-copyright">{f.copyright}</p>
      </div>
    </footer>
  );
};
